/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Tab, Tabs } from "@nordcloud/gnui";
import { useActionTabNavigation } from "~/hooks";
import { PlanEntityIncomingEventDetails } from "~/views/events/types";
import { TabIcon } from "~/views/plans/PlanDetails/Tabs/DetailsTab/components/ActionBox/components/TabIcon";
import { GeneralActionBatchSettings } from "./GeneralActionBatchSettings";
import { IncomingEventActionBatchDetails } from "./IncomingEventActionBatchDetails";

type Props = {
  planActionBatch?: PlanEntityIncomingEventDetails;
  planId?: string;
};

const ACTION_BATCH_TAB_STEP_MAPPING: Record<string, number> = {
  details: 0,
  general: 1,
};

export function IncomingEventActionBatchSettingsSection({
  planActionBatch,
  planId,
}: Props) {
  const { currentStep, handleTab } = useActionTabNavigation(
    ACTION_BATCH_TAB_STEP_MAPPING
  );

  return (
    <>
      <Tabs step={currentStep} handleTab={handleTab}>
        <Tab
          label={
            <span>
              <TabIcon caption="Action Batch Details" icon="eventLog" />
            </span>
          }
          width="auto"
        >
          <IncomingEventActionBatchDetails planActionBatch={planActionBatch} />
        </Tab>
        <Tab
          label={
            <span>
              <TabIcon
                caption="General Action Batch Settings"
                icon="settings"
              />
            </span>
          }
          width="auto"
        >
          <GeneralActionBatchSettings
            eventActionBatch={planActionBatch}
            planId={planId}
          />
        </Tab>
      </Tabs>
    </>
  );
}
